import Axios from "axios";

export class PepParticipacionService {

    lista(params) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/pep-participacion/lista?${queryParams}`).then(res => res.data);
    }

    nuevo(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/pep-participacion/nuevo`, data).then(res => res.data);
    }

    editar(data) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/ficha/pep-participacion/editar`, data).then(res => res.data);
    }

    eliminar(id, idp, opciones = {}) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/ficha/pep-participacion/eliminar/${id}/${idp}`, { params: opciones }).then(res => res.data);
    }

    consulta(id, idp, opciones = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/pep-participacion/consulta/${id}/${idp}`, { params: opciones }).then(res => res.data);
    }
}